import { Accordion,    Col,  Row } from "react-bootstrap"; 
import DetailItem from "../DataItem";
import { useNavigate } from "react-router-dom";
import TokenService from "../../../../Services/Token.service";
const ExcludedDonorsAccordion = ({ isExcludeDonors, excludedDonorIds, type }) => {
    
    const navigate = useNavigate();    
    const viewDetails = (donor_id) => {  
        TokenService.updatePrevLink('/admin/donor-management');
        //  navigate(`/admin/donor-management/donor-profile`, { state: { id: donor_id  } });
    }
    return (
        <> 
                    <Accordion.Item eventKey="8">
                        <Accordion.Header><b>Excluded Donors</b></Accordion.Header>
                        <Accordion.Body>
                    {isExcludeDonors && excludedDonorIds && excludedDonorIds.length > 0 ? (
                            <div className="el-property-details-card-content">
                                <Row>
                                    <Col md={12} className="mx-fit-content">
                                        <div className="flex-sec justify-content-between col-xxl-6">
                                        {excludedDonorIds.map((id, index) => ( 
                                            (type === 'requestor' ? (<>
                                                <DetailItem

                                                    title="Donor ID"
                                                    detail={id || '-'}
                                                />
                                            </>) : (
                                                <>
                                                    <div className="el-flex-area mb-3">
                                                        <div className="el-content-detail">
                                                            <p className="el-request-detail-profile-title">Donor ID :
                                                                <span className="el-request-detail-profile-name">{<span  className="back-link" onClick={() => { viewDetails(id) }}> {id}</span> || '-'}</span></p>
                                                        </div>
                                                    </div>
                                                </>
                                            )) 
                                        ))}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                    ) : (
                        <p className="text-danger">No excluded donors to display.</p>
                    )}
                        </Accordion.Body>
                    </Accordion.Item>
            
        </>
    );
};
export default ExcludedDonorsAccordion